import { getParsedParams } from "@faire/deprecated-retailer-visitor-shared/components/Carousel/utils";
import {
  IProps,
  CarouselBase,
  BaseCarouselProps,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { BrandTile } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/BrandTile";
import { ILeanBrandTileAdapter } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { SignUpElement } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { IBrandTile } from "@faire/web-api--source/indigofair/data/IBrandTile";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import * as React from "react";

export const BrandTileCarousel: React.FC<BaseCarouselProps> = (props) => {
  const CarouselBaseComponent = CarouselBase as React.ComponentType<
    IProps<IBrandTile>
  >;

  const { onItemClick, requestId, layoutElement, onVisible } =
    React.useContext(Context);

  const { refS, refC } = getParsedParams();

  const getItems = () => {
    let layout_element_data = layoutElement.layout_element_data ?? [];
    if (props.filterItems !== undefined) {
      layout_element_data = layout_element_data.filter(props.filterItems);
    }

    return layout_element_data
      .map((layoutElementData) => layoutElementData["brand_tile"])
      .filter(isNotUndefined);
  };

  const renderBrandTileCarousel = (brandTile: IBrandTile, index: number) => {
    const leanBrandTile = ILeanBrandTileAdapter.fromIBrandTile(brandTile);
    const queryParamProps = props.brandPageQueryParams;

    return (
      <BrandTile
        type="carousel"
        onClick={() => {
          onItemClick?.(
            layoutElement.on_click_event_name ?? "",
            requestId,
            leanBrandTile?.brand?.token ?? ""
          );
        }}
        brandTile={leanBrandTile}
        key={leanBrandTile?.brand?.token ?? index}
        showMinimum={props.showBrandMinimum}
        brandPageQueryParams={(build) =>
          build({
            refS,
            refC: refC ?? queryParamProps?.refC,
            cat: queryParamProps?.cat,
          })
        }
        signUpTracking={{
          element: SignUpElement.CAROUSEL,
          sourceId: `${layoutElement.on_click_event_name}_brand_tile_carousel`,
        }}
      />
    );
  };

  const onItemsVisible = (items: IBrandTile[]) => {
    const itemTokens = items.map((item) => item?.token);
    if (layoutElement.on_click_event_name) {
      onVisible?.(
        layoutElement.on_click_event_name,
        requestId,
        itemTokens?.join(" ") ?? ""
      );
    }
  };

  return (
    <CarouselBaseComponent
      buttonsOffsetTop="calc(50% - 20px)"
      renderItem={renderBrandTileCarousel}
      items={getItems()}
      onItemsVisible={onItemsVisible}
      {...props}
    />
  );
};
